module.exports = __webpack_public_path__ + "static/media/medidas.e0a4bc90.png";